import snackbarHtml from './snackbar.component.html';
import './snackbar.component.scss';

class SnackbarController {
    constructor($scope, SnackbarService) {
        'ngInject';
        
        this.service = SnackbarService;
    }

    click(message) {
        if (!message.isDismissable) return;

        message.callback(message, true);
    }
}

let snackbarComponent = {
    bindings: {},
    template: snackbarHtml,
    controller: SnackbarController
}

export default snackbarComponent;